import React from 'react';
import PropTypes from 'prop-types';
import './QuestionRenderer.css';
import { getQuestionRenderer } from './rendererByQuestionType';

// missing renderers
/**
 [
    "SIMPLE_COMPOSITE",
    "TRIPLE_QUESTION_DROP_DOWN",
    "SUB_STAGE_SELECT",
]
 */

export const QuestionRenderer = (props) => {
  const {
    q,
    onselect = () => {},
    resetIntake = () => {},
    footer,
    className,
    getCustomRenderer,
  } = props;

  let Renderer = getCustomRenderer && getCustomRenderer(q);
  Renderer = Renderer || getQuestionRenderer(q);

  if (!Renderer) {
    console.error(`QuestionRenderer: "${q.type}" renderer not found`);
    return null;
  }
  return (
    <div className={`question-renderer ${className || ''}`}>
      <Renderer {...props} onselect={onselect} resetIntake={resetIntake} />
      { footer || null }
    </div>
  );
};

QuestionRenderer.propTypes = {
  q: PropTypes.object.isRequired,
  // MultiPages question renderer does not pass user prop
  user: PropTypes.object,
  footer: PropTypes.any,
  getCustomRenderer: PropTypes.func,
  onselect: PropTypes.func,
  resetIntake: PropTypes.func,
  showTitle: PropTypes.bool,
  className: PropTypes.string,
};
